import React, { useRef, useState } from 'react'
import { Dropdown, Text } from '@wework/dieter-ui'
import { useOnClickOutside } from 'utils/useOnClickOutside'

export default function FloorsDropDown({
  floors,
  currentFloor,
  classes,
  disabled,
  onSelect,
  open,
  handleToggle,
  handleClose,
}) {
  const ref = useRef()
  const [isOpen, setIsOpen] = useState(false)
  useOnClickOutside(ref, () => setIsOpen(false))

  return (
    <div data-testid="floor-picker" ref={ref}>
      <Dropdown
        open={isOpen}
        scrolling
        text={currentFloor.name}
        disabled={disabled}
        style={{ marginLeft: 4 }}
        button
        basic
        onClick={() => setIsOpen(!isOpen)}
      >
        <Dropdown.Menu>
          {floors.map(floor => {
            return (
              <Dropdown.Item
                onClick={() => {
                  onSelect(floor)
                  setIsOpen(false)
                }}
                disabled={disabled}
                value={floor}
                key={floor.uuid}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16,
                }}
              >
                <Text>{floor.name}</Text>
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}
